// 🎨 Colores oficiales según BadgeOne
const COLORS = {
  primary: "bg-primary text-white",
  secondary: "bg-[#13C296] text-white",
  dark: "bg-[#212B36] text-white",
  gray: "bg-[#637381] text-white",
  light: "bg-[#EFEFEF] text-[#212B36]",
  warning: "bg-[#F9C107] text-[#212B36]",
  danger: "bg-[#DC3545] text-white",
  success: "bg-[#3CA745] text-white",
  info: "bg-[#3BA2B8] text-white",
};

// 🏷 Mapea estados → colores oficiales
export const getTransferStatusBadgeColor = (status: string): string => {
  switch (status) {
    case "Solicitado":
      return COLORS.warning; // Amarillo
    case "Aprobado":
      return COLORS.info; // Celeste
    case "Confirmado":
      return COLORS.success; // Verde
    case "Rechazado":
      return COLORS.danger; // Rojo
    case "Cancelado":
      return COLORS.gray; // Gris
    case "Revertido":
      return COLORS.dark; // Negro suave (estado administrativo final)
    default:
      return COLORS.light; // Neutro
  }
};
